import { SELECT_OPTIONS } from './select-options';
import type { DateFormat } from '@/lib';

export const ACTIVITY_LOG_ACTIONS = SELECT_OPTIONS.activityLogActions;
export const ACTIVITY_LOG_ENTITY_TYPES = SELECT_OPTIONS.activityLogEntityTypes;

// Label lookup maps, derived from the canonical option lists so labels stay in
// one place. Used by the dynamic Activity Log filters dropdowns to label
// distinct action / entity_type values pulled from the database.
const ACTIVITY_LOG_ACTION_LABELS: Record<string, string> = Object.fromEntries(
  ACTIVITY_LOG_ACTIONS.map((option) => [option.value, option.label])
);
const ACTIVITY_LOG_ENTITY_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  ACTIVITY_LOG_ENTITY_TYPES.map((option) => [option.value, option.label])
);

// Title-case fallback for snake_case identifiers that don't have a curated label.
function humanizeSnakeCase(value: string): string {
  return value
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getActivityLogActionLabel(action: string): string {
  return ACTIVITY_LOG_ACTION_LABELS[action] ?? humanizeSnakeCase(action);
}

export function getActivityLogEntityTypeLabel(entityType: string): string {
  return ACTIVITY_LOG_ENTITY_TYPE_LABELS[entityType] ?? humanizeSnakeCase(entityType);
}

export const ACTIVITY_LOG_DATE_FIELDS = [
  'created_at',
  'start_time',
  'end_time',
  'start_date',
  'end_date',
  'timestamp',
  'class_start_time',
  'cancelled_at',
  'uploaded_at',
  'slot_start',
  'slot_end',
] as const;

// Returns the appropriate display format for activity-log date-like fields
export function getActivityLogDateFormat(fieldName: string): DateFormat {
  if (fieldName === 'start_date' || fieldName === 'end_date') {
    return 'date'; // Date-only for membership date fields
  }
  return 'full'; // Full datetime for created_at, start_time, end_time, timestamp, etc.
}